export default __webpack_public_path__ + "static/media/deleteIcon.83bdb17a.svg";